import extraMarketingSchema from './marketingSchema';
import translationSchema from '../translationSchema';

const extraCreationSchema = extraMarketingSchema.concat(translationSchema.required);

export default extraCreationSchema;
